import { render, staticRenderFns } from "./ProfitStatement.vue?vue&type=template&id=53bb6bda&scoped=true"
import script from "./ProfitStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfitStatement.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProfitStatement.vue?vue&type=style&index=0&id=53bb6bda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bb6bda",
  null
  
)

export default component.exports